module.exports = __webpack_public_path__ + "media/img/private-venue/bg-hover-work-8efa69e89bcce06d1e9a1853e759acfd.png";